import type { AiToolkitCalendarEvent } from "@mem-client/ai-toolkit/contract";
import type { SpaceAccountCalendarEventObservable } from "@/store/calendar/space-account-calendar-event/SpaceAccountCalendarEventObservable";

type CalendarEventSource = Pick<
  SpaceAccountCalendarEventObservable,
  | "associatedConnectedCalendarEventId"
  | "associatedNote"
  | "calendarEmailAddress"
  | "calendarName"
  | "endTime"
  | "id"
  | "isAllDay"
  | "isHidden"
  | "meetingPlatform"
  | "modelData"
  | "primaryLabel"
  | "startTime"
  | "url"
>;

export const buildCalendarEvent = ({
  event,
}: {
  event: CalendarEventSource;
}): AiToolkitCalendarEvent => ({
  id: event.id,
  associatedConnectedCalendarEventId: event.associatedConnectedCalendarEventId,
  title: event.primaryLabel ?? null,
  startTime: event.startTime ?? null,
  endTime: event.endTime ?? null,
  isAllDay: event.isAllDay,
  isHidden: event.isHidden,
  attendeeCount: event.modelData.attendee_count ?? null,
  selfResponseStatus: event.modelData.self_response_status ?? null,
  meetingUrl: event.url ?? null,
  meetingPlatform: event.meetingPlatform,
  calendarName: event.calendarName ?? null,
  calendarEmailAddress: event.calendarEmailAddress ?? null,
  associatedNote: event.associatedNote
    ? {
        id: event.associatedNote.id,
        title: event.associatedNote.title,
        path: event.associatedNote.path,
      }
    : null,
});
